import styled from 'styled-components';

export const CurrentPriceStyled = styled.div`
display: flex;
flex-direction: column;
gap: 10;
cursor: default !important;
  .label {
    color: #5e6672;
    font-weight: 700;
    white-space: nowrap;
  }
  .value {
    padding: .67857143em 1em;
    border: 1px solid rgba(34, 36, 38, .15);
    border-radius: .28571429rem;
    line-height: 1.21428571em;
  }
`